import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styled from '@emotion/styled';
import { Button, EmotionBreakpoint } from 'dw-us-ui';
import { useHistory } from 'react-router-dom';
import RichText from '../../../util/RichText';

const ButtonWithContentSectionContainer = styled.div`
  padding: 30px 15px 10px 15px;
  .align-btn {
    padding: 15px;
  }
  .content-font-style {
    font-weight: bolder;
  }
  .justify-content-center {
    justify-content: center;
    display: flex;
  }
  ${EmotionBreakpoint('notDesktop')} {
    button {
      font-size: 12px;
      padding: 0 10px;
    }
  }
`;

const ButtonWithContentSection = ({ fields }) => {
  const history = useHistory();
  let buttonDetails = {};

  const getValue = blocks => {
    blocks.map(ele => {
      switch (ele?.sys?.contentType?.sys?.id) {
        case 'link':
          buttonDetails['text'] = ele.fields.text;
          buttonDetails['url'] = ele.fields.url;
          break;

        case 'textBlockWithMobile': {
          buttonDetails['title'] = ele.fields.title;
          buttonDetails['content'] = ele?.fields?.content ? RichText(ele.fields.content) : null;
          break;
        }
        default: {
          return null;
        }
      }
    });
  };
  getValue(fields?.blocks);

  return (
    <ButtonWithContentSectionContainer data-testid="button-with-content-section">
      {buttonDetails?.title && (
        <Row className="mb-3">
          <Col data-testid="content-title" className="text-center">
            {buttonDetails?.title}
          </Col>
        </Row>
      )}
      {buttonDetails?.content && (
        <div className="mx-0">
          <div data-testid="content-text" className="text-center content-font-style">
            {buttonDetails?.content}
          </div>
        </div>
      )}
      <div className="justify-content-center">
        <div lg={4} sm={5} xs={9} className="my-4 align-btn">
          <Button
            buttonType="primary"
            buttonSize="small"
            onClick={() => {
              window.location.href = buttonDetails?.url;
            }}
          >
            {buttonDetails?.text}
          </Button>
        </div>
      </div>
    </ButtonWithContentSectionContainer>
  );
};

export { ButtonWithContentSection };
